var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_47_127)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 47.5,
    r: 41.5,
    fill: "#0876A4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6473 46.6919H65.3132C66.0103 46.6919 66.6379 46.2736 66.9169 45.646C67.1958 45.0186 67.0562 44.2517 66.5682 43.7637L58.0623 34.9092C57.3999 34.2121 56.3193 34.1771 55.6222 34.8395C54.9251 35.5019 54.89 36.5825 55.5524 37.2796L61.2347 43.2057L35.6474 43.206C34.7061 43.206 33.9044 43.9729 33.9044 44.949C33.9044 45.9251 34.6713 46.692 35.6474 46.692L35.6473 46.6919Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2781 49.9688H35.6471C34.9499 49.9688 34.3223 50.387 34.0434 51.0146C33.7645 51.642 33.904 52.4089 34.3921 52.8969L42.863 61.7514C43.2117 62.1001 43.6648 62.2742 44.118 62.2742C44.5363 62.2742 44.9895 62.0998 45.3032 61.7861C46.0003 61.1237 46.0354 60.0431 45.373 59.346L39.6907 53.4199H65.278C66.2193 53.4199 67.021 52.6529 67.021 51.6769C67.0212 50.7358 66.2543 49.9688 65.2782 49.9688L65.2781 49.9688Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_47_127",
    x: 0,
    y: 0,
    width: 103,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.500469 0 0 0 0 0.500469 0 0 0 0 0.500469 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_47_127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_47_127",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.0f9ee23df90a4df1c0898ebc704ab789.svg";
export { ForwardRef as ReactComponent };